/**
 * Module dependencies.
 */

import { ListItem as ListItemProps } from 'src/types/technologies';
import { ReactElement } from 'react';
import { Type } from 'src/components/core';
import { color, units } from '@untile/react-components';
import map from 'lodash/map';
import styled from 'styled-components';

/**
 * `Props` type.
 */

type Props = {
  className?: string;
  items: ListItemProps[];
  label: string;
};

/**
 * `Wrapper` styled component.
 */

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
`;

/**
 * `Label` styled component.
 */

const Label = styled(Type.H3)`
  margin-bottom: ${units(2)};
`;

/**
 * `ListItem` styled component.
 */

const ListItem = styled.li`
  list-style-type: initial;
  margin-left: ${units(2)};

  &::marker {
    color: ${color('grey100')};
  }
`;

/**
 * `List` component.
 */

const List = (props: Props): ReactElement => {
  const { className, items, label } = props;

  return (
    <Wrapper className={className}>
      <Label>{label}</Label>

      <ul>
        {map(items, ({ item, key }) => (
          <ListItem key={key}>{item}</ListItem>
        ))}
      </ul>
    </Wrapper>
  );
};

/**
 * Export `List` component.
 */

export default List;
